import axiosClient from './setup/axiosClient';

export const PaymentSummaryV2Apis = {
  getMobileBillPaymentList: async (params: {
    customerId?: string;
    teamSaleId?: string;
    page?: number;
    limit?: number;
    fromDate?: string;
    toDate?: string;
    statusId?: string;
    plantId?: string;
    id?: string;
    createId?: string;
  }): Promise<any> => {
    const custId = params.customerId || 'all';
    const teamId = params.teamSaleId || 'all';
    return axiosClient.get(
      `/payment/mobile/bill-payment-list/${custId}/${teamId}`,
      { params },
    );
  },

  getMobileBillPaymentDetail: async (id: string): Promise<any> => {
    return axiosClient.get(`/payment/mobile/bill-payment/${id}`);
  },

  getMobileAvailableOrders: async (params: {
    customerId: string;
    teamId: string;
    sumPaymentId?: string;
  }): Promise<any> => {
    return axiosClient.get('/payment/mobile/available-orders', { params });
  },

  getMobileSapDebtItems: async (params: {
    customerId: string;
    teamId?: string;
    sumPaymentId?: string;
  }): Promise<any> => {
    return axiosClient.get('/payment/mobile/sap-debt-items', { params });
  },

  resolveSapDebt: async (params: {
    bill: string;
    miro: string;
  }): Promise<any> => {
    return axiosClient.get('/payment/mobile/resolve-sap-debt', { params });
  },

  createBillPayment: async (data: any): Promise<any> => {
    return axiosClient.post('/payment/mobile/create-bill-payment', data);
  },

  updateBillPayment: async (data: any): Promise<any> => {
    return axiosClient.post('/payment/mobile/update-bill-payment', data);
  },

  recalculateBillPayment: async (data: any): Promise<any> => {
    return axiosClient.post('/payment/mobile/bill-payment-recalculate', data);
  },

  getMobileQrCodes: async (paymentId: string): Promise<any> => {
    return axiosClient.get(`/payment/mobile/qr-codes/${paymentId}`);
  },

  createQrCode: async (data: any): Promise<any> => {
    return axiosClient.post('/payment/mobile/create-qr-code', data);
  },

  saveQr: async (data: any): Promise<any> => {
    return axiosClient.post('/payment/mobile/save-qr', data);
  },

  checkQrStatus: async (data: { txnId: string }): Promise<any> => {
    return axiosClient.post('/payment/mobile/check-qr-status', data);
  },

  checkAllQrStatus: async (data: { paymentId: string }): Promise<any> => {
    return axiosClient.post('/payment/mobile/check-all-qr-status', data);
  },

  sendSapFull: async (data: { paymentId: string }): Promise<any> => {
    return axiosClient.post('/payment/mobile/send-sap-full', data);
  },

  sendSapPartial: async (data: {
    paymentId: string;
    detailId?: string;
    orderId?: string;
  }): Promise<any> => {
    return axiosClient.post('/payment/mobile/send-sap-partial', data);
  },

  mockQrSuccess: async (data: { transactionLogId: string }): Promise<any> => {
    return axiosClient.post('/payment/mobile/mock-qr-success', data);
  },

  exportHddtV2: async (data: {
    paymentId?: string;
    orderIds: string[];
  }): Promise<any> => {
    return axiosClient.post('/payment/mobile/orders-hddt', {
      orderIds: data.orderIds,
    });
  },

  createBillSap: async (data: any): Promise<any> => {
    return axiosClient.post('/sap/create-bill', data);
  },

  createEinvoiceSap: async (orderId: string, data: any): Promise<any> => {
    return axiosClient.post(`/sap/create-einvoice/${orderId}`, data);
  },

  getMobilePaymentDetails: async (paymentId: string): Promise<any> => {
    return axiosClient.get(`/payment/mobile/payment-details/${paymentId}`);
  },

  deleteBillPaymentV2: async (data: { id: string }): Promise<any> => {
    return axiosClient.delete(`/payment/mobile/delete-bill-payment/${data.id}`);
  },
};
